// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class PasswordThreeConsecutiveCharactersNotAllowedConstraint implements IConstraintModel {
  _maxSequence: number;

  /**
   */
  constructor(maxSequence: number = 2) {
    this._maxSequence = maxSequence;
  }

  /**
   */
  get id(): string {
    return "Constraint.Password.ThreeConsecutiveCharactersNotAllowed";
  }

  /**
   */
  get maxSequence(): number {
    return this._maxSequence;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must not contain any character more than twice consecutively";
  }

  /**
   */
  get parameters(): { "max-sequence": number } {
    return {
      "max-sequence": this.maxSequence,
    };
  }

  /**
   */
  hasNoSequenceOfIdenticalCharacters(value: string): boolean {
    return !value
      .split("")
      .filter((char, i) => value.indexOf(char) === i)
      .some((char) => {
        const sequence = char.repeat(this.maxSequence + 1);
        return value.includes(sequence);
      });
  }

  /**
   */
  validate(value: string): boolean {
    return this.hasNoSequenceOfIdenticalCharacters(value);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default PasswordThreeConsecutiveCharactersNotAllowedConstraint;
